import { getGameSituation } from '../game-situation.ts'
import { GameSituation } from '../types/game-situation.ts'
import applyHeatmap from './heatmaps.ts'
import { RunExpectancyByCountRow } from '../types/run-expectancy.ts'
import { Runners } from '../types/runners.ts'

export default function renderRunExpectancyByCountSelectedTable(
    data: RunExpectancyByCountRow[]
) {
    if (!data.length) {
        console.warn('No run expectancy data returned')
    }

    const table = `
<table id="tbl-run-exp-by-count-selected">
  <thead>
    <tr><th></th></tr>
    <tr class="tr-component-row">
      <th class="th-component-header align-center">Runners</th>
      <th class="th-component-header align-center">Count</th>
      <th class="th-component-header align-center" data-outs="0">0 Outs</th>
      <th class="th-component-header align-center" data-outs="1">1 Out</th>
      <th class="th-component-header align-center" data-outs="2">2 Outs</th>
    </tr>
  </thead>
  <tbody>
    ${data
        .map((row) => {
            const count = `${row.ball_count}-${row.strike_count}`

            return `
<tr
  class="default-table-row" 
  data-count="${count}"
  data-runners="${row.runners_on_cd}"
>
  <td class="tr-data align-center">${row.bases}</td>
  <td class="tr-data align-center">${count}</td>
  <td class="tr-data align-center" data-situation="0">${
      row.run_expectancy_0_out != null
          ? row.run_expectancy_0_out.toFixed(3)
          : ''
  }</td>
  <td class="tr-data align-center" data-situation="1">${
      row.run_expectancy_1_out != null
          ? row.run_expectancy_1_out.toFixed(3)
          : ''
  }</td>
  <td class="tr-data align-center" data-situation="2">${
      row.run_expectancy_2_out != null
          ? row.run_expectancy_2_out.toFixed(3)
          : ''
  }</td>
</tr>`
        })
        .join('')}
  </tbody>
</table>
`

    const el = document.getElementById('run-exp-count')

    if (el) {
        el.innerHTML = table
    }
    highlightMatchingRowByCountSelected(getGameSituation())
    applyHeatmap('tbl-run-exp-by-count-selected')
}

function highlightMatchingRowByCountSelected(
    situation: Partial<GameSituation>
) {
    // Clear previous highlights ONLY in the by-count table
    document
        .querySelectorAll('#run-exp-count .cell-highlight')
        .forEach((el) => el.classList.remove('cell-highlight'))

    if (situation.balls == null || situation.strikes == null) {
        return
    }
    const countKey = `${computeBasesCd(situation.runners)}`
    const rows = document.querySelectorAll<HTMLTableRowElement>(
        '#run-exp-count table tbody tr'
    )

    rows.forEach((row) => {
        if (row.dataset.runners !== countKey) return

        const cell = row.querySelector<HTMLElement>(
            `[data-situation="${situation.outs}"]`
        )

        if (cell) {
            cell.classList.add('cell-highlight')
        }
    })
}

function computeBasesCd(runners: Runners = {}) {
    let bases_cd = 0
    if (runners['1b']) bases_cd += 1
    if (runners['2b']) bases_cd += 2
    if (runners['3b']) bases_cd += 4
    return bases_cd
}
